import { TileLayer } from "@deck.gl/geo-layers"
import type { TileLayerProps, _TileLoadProps as TileLoadProps } from "@deck.gl/geo-layers"
import { UpdateParameters } from "@deck.gl/core"

export const tileLoadTracker = (() => {
    let pending = 0
    let idleWaiters: (() => void)[] = []

    const settle = () => {
        pending--
        if (pending > 0) return
        const waiters = idleWaiters
        idleWaiters = []
        waiters.forEach((resolve) => resolve())
    }

    return {
        track: async <T>(load: Promise<T>) => {
            pending++
            try {
                return await load
            } finally {
                settle()
            }
        },
        waitForIdle: () =>
            pending === 0
                ? Promise.resolve()
                : new Promise<void>((resolve) => {
                      idleWaiters.push(resolve)
                  }),
    }
})()

const isSameExtent = (a: number[] | null | undefined, b: number[] | null | undefined) => {
    if (a === b) return true
    if (!a || !b) return false
    return a.length === b.length && a.every((value, index) => value === b[index])
}

export class TrackedTileLayer extends TileLayer<ImageData | null, TileLayerProps> {
    static layerName = "TrackedTileLayer"

    getTileData(tile: TileLoadProps) {
        const result = super.getTileData(tile)
        return result instanceof Promise ? tileLoadTracker.track(result) : result
    }

    updateState(params: UpdateParameters<this>) {
        const { changeFlags, props, oldProps } = params
        const tileset = this.state.tileset

        if (changeFlags.propsChanged && !isSameExtent(props.extent, oldProps?.extent) && tileset) {
            // @ts-expect-error setOptions uses Object.assign under the hood
            tileset.setOptions({ extent: props.extent })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ;(tileset as any)._viewport = null
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ;(this as any)._updateTileset()
        }

        super.updateState(params)
    }
}
